export const DATE_FIELD_NAMES = ['dateFrom', 'dateTo'];
